import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';

const AdminPanelAccountEditFeatures = ({
  features,
  client,
  handleChange,
}) => {
  const clientHasFeature = (featureSlug) => (
    client.features.find(f => (f.slug === featureSlug))
  );

  const isFeatureLocked = (feature) => {
    if (client.is_complimentary || client.manual_subscription || client.is_in_trial) {
      return true;
    }

    if (feature.plans && client.plan) {
      return feature.plans.find(fp => (fp.slug === client.plan.slug));
    }

    return false;
  };

  return (
    <Row className="mb-4">
      <Col sm={12}>
        {client.is_in_trial && (
          <p className="warning">Features are locked while the client is in trial.</p>
        )}
        {features.map(feature => (
          <FormGroup check key={feature.slug} className="feature">
            <Label for={`feature-${feature.slug}`} check>
              <Input
                type="checkbox"
                id={`feature-${feature.slug}`}
                name={feature.slug}
                defaultChecked={clientHasFeature(feature.slug)}
                disabled={isFeatureLocked(feature)}
                onChange={handleChange}
              />
              {feature.name}
              {(feature.plans && feature.plans.length > 0) && (
                <span>({feature.plans.map(fp => (fp.name)).join(', ')})</span>
              )}
            </Label>
          </FormGroup>
        ))}
      </Col>
    </Row>
  );
};

const mapStateToProps = state => ({
  features: state.App.features,
});

AdminPanelAccountEditFeatures.propTypes = {
  features: PropTypes.array.isRequired,
  client: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(AdminPanelAccountEditFeatures);
